// extracted by mini-css-extract-plugin
export default {"notificationCircle":"Changes_notificationCircle__c-jPX","notificationWrapper":"Changes_notificationWrapper__OhgpK","notificationTooltip":"Changes_notificationTooltip__FHppS"};